'use client';

import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@phosphor-icons/react';

import { PageHeader } from '@/components/PageHeader';
import { PageSkeleton } from '@/components/PageSkeleton';
import { CategoryBreakdown, type TaggedRecurring } from '@/components/recurring-payments/CategoryBreakdown';
import { useRecurringOverview } from '@/hooks/queries/useRecurringPayments';
import type { RecurringGroupKey } from '@/lib/api';

export function RecurringBreakdownView() {
  const { data: overviewData, isLoading: overviewLoading } = useRecurringOverview();

  const categoryEntries = useMemo(() => {
    const groups = overviewData?.groups ?? [];
    const itemsFor = (key: RecurringGroupKey) => groups.find((g) => g.key === key)?.items ?? [];
    const tagged = (key: RecurringGroupKey): TaggedRecurring[] =>
      itemsFor(key).map((item) => ({ item, tipo: key }));
    return [...tagged('parcelamentos'), ...tagged('assinaturas'), ...tagged('fixas')];
  }, [overviewData?.groups]);

  if (overviewLoading && !overviewData) return <PageSkeleton />;

  return (
    <div className="mx-auto max-w-5xl animate-in space-y-5 duration-500 fade-in">
      <Link
        to="/recurring-payments"
        className="inline-flex items-center gap-1.5 text-sm font-medium text-text-secondary hover:text-text-primary"
      >
        <ArrowLeftIcon className="size-4" />
        Voltar
      </Link>

      <PageHeader
        title="Detalhamento"
        titleClassName="font-display font-semibold text-2xl sm:text-[26px]"
        description="Recorrências por categoria"
      />

      <CategoryBreakdown entries={categoryEntries} />
    </div>
  );
}
